import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Headers, Response, RequestOptions } from '@angular/http';
import { AuthHttp } from "angular2-jwt/angular2-jwt";
import { ClienteLogin } from '../../../views/login/cliente_login';
import { ConstantService } from "../../../components/common/utils/constant.service";
import { SessionStorageService } from "ngx-webstorage";
import { VamBancosEntity, DevolucionSeguroTitularVam } from '../../vam/vam_entity';

@Injectable()
export class RenunciaBeneficioSeguroService {
    usuario: ClienteLogin;
    private url = "vamTittular";
    private url2 = "utils"
    constructor(public authHttp: AuthHttp, private sessionStorageService: SessionStorageService) {
        let constantService = new ConstantService();
        this.url = constantService.API_ENDPOINT + this.url;
        this.url2 = constantService.API_ENDPOINT + this.url2;
    }

    ConsultarBancos(): Observable<VamBancosEntity[]>{
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.get(this.url2 + "/getBancosVam/", options).map(this.extractData)
            .catch(this.handleError);
    }

    SolicitarRenunciaBeneficio(solicitud: DevolucionSeguroTitularVam): Observable<boolean>{
        let body = JSON.stringify(solicitud);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/RenunciarBeneficioMedico", body, options).map(this.extractData)
            .catch(this.handleError);
    }
    AnulacionRenunciarBeneficioMedico(titular, cliente,ciudad): Observable<boolean> {
        return this.authHttp.get(this.url + "/AnulacionRenunciarBeneficioMedico/" + titular + "/" + cliente+ "/" + ciudad).map(this.extractData)
            .catch(this.handleError);
    }


    private extractData(res: Response) {
        let body = res.json();
        return body || {};
    }
    private handleError(error: any) {
        return Observable.throw(error);
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/paginas_por_cliente/catolica_quito/renuncia-beneficio-seguro.service.ts